import {GAME_TYPES} from "../../../constants/game";
import {SPECTATOR_ID} from "../../../constants/players";
import {
  selectCurrentPlayer,
  selectGameType,
  selectPendingBuildings,
  selectPlayers
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {selectUserId} from "../../../redux/reducers/privateStateReducer/selectors";
import {getActingPlayer} from "../../players/getActingPlayer";
import {selectTurnDisplayedPlayer} from "../supply/parallelSupplySelectors";
import {selectConstructionPlanStatsView} from "../construction/planning/buildConstructionPlanningViewState";

const NO_PENDING_BUILDINGS = Object.freeze([]);

let cachedView = null;

/**
 * «Свой игрок» для левой зоны шапки — чьи ресурсы и политику она показывает.
 * - Сетевая игра: игрок этого клиента (или бот, которым управляет админ), а
 *   не ходящий — в чужой ход в шапке остаются свои монеты и очки.
 * - Локальная игра с одним живым игроком (обучение, игра против ботов): этот
 *   игрок — как лента «вы» в списке игроков. Hot-seat нескольких людей:
 *   ходящий (selectTurnDisplayedPlayer).
 * - Зритель (сетевой, запись матча, локальный режим зрителя): своего игрока
 *   нет — null. Ходящего ему показывает плашка под его кружком в строке
 *   игроков (selectHeaderActingPlayerBadgePlayer).
 * Планирующему игроку в чужой ход строительства стата подменяется статой с
 * учетом плана (selectConstructionPlanStatsView).
 *
 * @param {Object} state
 * @param {boolean} [isSpectatorMode] локальный режим зрителя (проп матча):
 *   из состояния его не узнать
 * @returns {{player: Object, pendingBuildings: Array}|null}
 */
export const selectHeaderOwnPlayerView = (state, isSpectatorMode = false) => {
  if (isSpectatorMode) {
    return null;
  }
  const gameType = selectGameType(state);
  const players = selectPlayers(state) || [];
  const turnDisplayedPlayer = selectTurnDisplayedPlayer(state);

  let ownPlayer;
  if (gameType === GAME_TYPES.LOCAL) {
    const humanPlayers = players.filter((player) => !player.isBot);
    ownPlayer = humanPlayers.length === 1 ? humanPlayers[0] : turnDisplayedPlayer;
  } else {
    const actingPlayer = getActingPlayer(gameType, selectUserId(state), players, selectCurrentPlayer(state));
    if (!actingPlayer || actingPlayer.id === SPECTATOR_ID) {
      return null;
    }
    ownPlayer = actingPlayer;
  }

  if (!ownPlayer) {
    return null;
  }

  const planView = selectConstructionPlanStatsView(state);
  let player = ownPlayer;
  let pendingBuildings;
  if (planView && planView.player.id === ownPlayer.id) {
    player = planView.player;
    pendingBuildings = planView.pendingBuildings;
  } else {
    // Отложенные строения в состоянии — это ход того, кто ходит: чужому
    // игроку они не принадлежат
    pendingBuildings = turnDisplayedPlayer && turnDisplayedPlayer.id === ownPlayer.id
      ? (selectPendingBuildings(state) || NO_PENDING_BUILDINGS)
      : NO_PENDING_BUILDINGS;
  }

  if (cachedView
    && cachedView.player === player
    && cachedView.pendingBuildings === pendingBuildings
  ) {
    return cachedView;
  }
  cachedView = {player, pendingBuildings};
  return cachedView;
};
